export default {
  container: { background: '#fff', padding: 12, minHeight: '580px' },
  a4Page: {
    minHeight: '297mm',width: '210mm', margin: '0 auto 0 auto',
    padding: '10mm', border: 1,
    backgroundColor: '#fff',
  },

}



// WEBPACK FOOTER //
// src/styles.js